import { PartnerType } from "./partners.enum";

export enum CrefisaActivityEnum {
  CANCELADA = "CANCELADA",
  FINALIZADO = "FINALIZADO",
  AGUARDANDO_FORMALIZACAO_CLIENTE = "AGUARDANDO FORMALIZACAO CLIENTE",
  PENDENTE_TRANSF_PIX = "PENDENTE TRANSF. PIX",
  CANCELADO_PELA_CONFIRMACAO = "CANCELADO PELA CONFIRMAÇÃO",
  PAGAMENTO_PENDENTE = "PAGAMENTO PENDENTE",
  PENDENTE = "PENDENTE",
  APROVADA = "APROVADA",
  EM_ANALISE = "EM ANALISE",
  REJEITADO = "REJEITADO",
  CANCELADO = "CANCELADO",
  GERADO_E_ENVIADO = "GERADO E ENVIADO",
  MOBILE = "MOBILE",
  AGUARDANDO_ANALISE = "AGUARDANDO ANALISE",
  AGUARDANDO_MOTOR = "AGUARDANDO MOTOR",
  EXPIRADA = "EXPIRADA",
}

export const crefisaActivityLabels: Record<CrefisaActivityEnum, string> = {
  [CrefisaActivityEnum.CANCELADA]: "Cancelada",
  [CrefisaActivityEnum.FINALIZADO]: "Finalizado",
  [CrefisaActivityEnum.AGUARDANDO_FORMALIZACAO_CLIENTE]:
    "Aguardando formalização do cliente",
  [CrefisaActivityEnum.PENDENTE_TRANSF_PIX]: "Pendente transf. PIX",
  [CrefisaActivityEnum.CANCELADO_PELA_CONFIRMACAO]:
    "Cancelado pela confirmação",
  [CrefisaActivityEnum.PAGAMENTO_PENDENTE]: "Pagamento pendente",
  [CrefisaActivityEnum.PENDENTE]: "Pendente",
  [CrefisaActivityEnum.APROVADA]: "Aprovada",
  [CrefisaActivityEnum.EM_ANALISE]: "Em análise",
  [CrefisaActivityEnum.REJEITADO]: "Rejeitado",
  [CrefisaActivityEnum.CANCELADO]: "Cancelado",
  [CrefisaActivityEnum.GERADO_E_ENVIADO]: "Gerado e enviado",
  [CrefisaActivityEnum.MOBILE]: "Mobile",
  [CrefisaActivityEnum.AGUARDANDO_ANALISE]: "Aguardando análise",
  [CrefisaActivityEnum.AGUARDANDO_MOTOR]: "Aguardando motor",
  [CrefisaActivityEnum.EXPIRADA]: "Expirada",
};

export const optionsCrefisaActivitySelect = Object.values(
  CrefisaActivityEnum,
).map((activity) => ({
  value: activity,
  label: crefisaActivityLabels[activity],
}));

/** Produtos que gravam `activity` na transação. */
export const CREFISA_PRODUCTS: string[] = [
  PartnerType.CREFISA,
  PartnerType.CREFISA_INSS,
];

export const hasCrefisaProduct = (products: (string | number)[] = []) =>
  products.some((product) => CREFISA_PRODUCTS.includes(String(product)));
